module.exports = __webpack_public_path__ + "static/img/yinliangjia2.e265dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yinliangjia2.png
// module id = dFnC
// module chunks = 24